import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";

import EditTextWithTextInput from "core/EditTextWithTextInput";

import { TitleFieldContainer } from "./styles";

import { SET_PHOTO_UPLOAD_TITLE } from "./mutations";

import { useEditPhotoUpload } from "./EditPhotoUploadContext";

import { detectEmoji } from "frontend/components/helpers";
import { getBeToFeErrMsgRemap } from "frontend/components/creator-tools/PhotoUploadPage/helpers.js";
import { titleInvalidCharError, errMsgMappings } from "./constants";

const TitleSection = () => {
    const [errorMessage, setErrorMessage] = useState("");
    const [setPhotoUploadTitle] = useMutation(SET_PHOTO_UPLOAD_TITLE);

    const { uploads } = useEditPhotoUpload();

    // user can edit only one upload title at a time
    if (uploads.length !== 1) return null;

    const upload = uploads[0];

    const updateTitle = title => {
        return setPhotoUploadTitle({
            variables: {
                id: upload.id,
                value: title
            }
        });
    };

    const handleNewTitleSubmit = (title, exitEditingMode) => {
        const trimmedTitle = title.trim();
        const hasEmoji = detectEmoji(trimmedTitle);

        if (hasEmoji) {
            setErrorMessage(titleInvalidCharError);
            return;
        }

        if (trimmedTitle.length > 0 && trimmedTitle.length < 3) {
            setErrorMessage(
                "Photo titles must be at least 3 characters long. Please use a different title."
            );
        } else {
            updateTitle(trimmedTitle).then(response => {
                const {
                    data: {
                        setPhotoUploadTitle: { ok, errors: beErrMsg }
                    }
                } = response;

                const customMessage = getBeToFeErrMsgRemap(
                    beErrMsg,
                    errMsgMappings.title
                );

                if (ok) {
                    setErrorMessage("");
                    exitEditingMode();
                } else if (customMessage) {
                    setErrorMessage(customMessage.fe);
                } else {
                    setErrorMessage(
                        "Sorry, something went wrong. Please try again."
                    );
                }
            });
        }
    };

    const inputAttributes = {
        maxLength: "255",
        minLength: "3"
    };

    return (
        <TitleFieldContainer>
            <EditTextWithTextInput
                defaultDisplayText="Add Title"
                displayText={upload.photoTitle}
                buttonAriaLabel="Edit title"
                placeholderText="Title (Optional)"
                labelText="Title (Optional)"
                onNewTextSubmit={handleNewTitleSubmit}
                errorMessage={errorMessage}
                {...inputAttributes}
            />
        </TitleFieldContainer>
    );
};

export default TitleSection;
